(function () {
  const items = document.querySelectorAll('.nav-item.has-children');

  items.forEach(item => {
    const details = item.querySelector('details.header-dropdown');
    const summary = item.querySelector('.nav-link');
    const panel = item.querySelector('.mega-panel');
    if (!details || !summary || !panel) return;

    const openPanel = () => {
      panel.classList.add('open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
      summary.setAttribute('aria-expanded', 'true');
      details.setAttribute('open', 'open');
    };

    const closePanel = () => {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      panel.offsetHeight; // reflow
      panel.style.maxHeight = '0px';
      summary.setAttribute('aria-expanded', 'false');
      const tidy = (e) => {
        if (e.propertyName === 'max-height' && panel.style.maxHeight === '0px') {
          panel.classList.remove('open');
          details.removeAttribute('open');
          panel.removeEventListener('transitionend', tidy);
        }
      };
      panel.addEventListener('transitionend', tidy);
    };

    // Desktop: hover
    let t;
    item.addEventListener('mouseenter', () => { if (window.matchMedia('(min-width: 990px)').matches) { clearTimeout(t); openPanel(); }});
    item.addEventListener('mouseleave', () => { if (window.matchMedia('(min-width: 990px)').matches) { t = setTimeout(closePanel, 120); }});

    // Clavier
    item.addEventListener('focusin', () => { if (window.matchMedia('(min-width: 990px)').matches) openPanel(); });
    item.addEventListener('focusout', (e) => { if (window.matchMedia('(min-width: 990px)').matches && !item.contains(e.relatedTarget)) closePanel(); });

    // Mobile: toggle au clic
    summary.addEventListener('click', (e) => {
      if (window.matchMedia('(max-width: 989px)').matches) {
        e.preventDefault();
        panel.classList.contains('open') ? closePanel() : openPanel();
      }
    });

    // Si des images chargent, recalcule la hauteur ouverte
    panel.querySelectorAll('img').forEach(img => {
      img.addEventListener('load', () => {
        if (panel.classList.contains('open')) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  });

  // Ferme si clic en dehors
  document.addEventListener('click', (e) => {
    document.querySelectorAll('.mega-panel.open').forEach(panel => {
      const item = panel.closest('.nav-item');
      if (!item.contains(e.target)) {
        panel.style.maxHeight = '0px';
        panel.classList.remove('open');
        const summary = item.querySelector('.nav-link');
        const details = item.querySelector('details.header-dropdown');
        if (summary) summary.setAttribute('aria-expanded', 'false');
        if (details) details.removeAttribute('open');
      }
    });
  });
})();
